// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleAttachmentItem_wrapper__V9JY8","text":"MultipleAttachmentItem_text__f7kUE","button":"MultipleAttachmentItem_button__9XJxG"};